import React from 'react';
import './Header.css';
import LinkButton from './LinkButton';
import { FaHome, FaList, FaHeart, FaDiscord } from 'react-icons/fa';

function Header({ scrollToSection, heroRef, featuresRef, toggleSnow }) {
    return (
        <header className="header">
            <a href="/" className="header-logo">
                 <img src="https://media.discordapp.net/attachments/1284993873038413824/1332021650366922905/photo_2024-12-31_16-29-21.jpg?ex=6793bd55&is=67926bd5&hm=94f4c6751ea9ef4506dfcd34f3c86e95493812e0e5c8eed0e27d4f52b75e0fce&=&format=webp&width=662&height=662" alt="Lunar Avatar" className="header-logo-img" loading="lazy"/>
            </a>
            <nav className="header-nav">
             <a href="https://discord.gg/xyPcecG9hq" className="header-link"  target="_blank" rel="noopener noreferrer">
                    <FaDiscord className="header-icon" />
                    Сервер поддержки
                </a>

            </nav>
            <div className="header-actions">
              <a href="https://www.donationalerts.com/r/jesusikneavgn" target="_blank" rel="noopener noreferrer" className="help-link">
                  <FaHeart  className="header-icon"/>
                  Помочь проекту
             </a>
                <LinkButton text="Добавить меня" href="https://discord.com/oauth2/authorize?client_id=1248175100336013363&permissions=573174659149558&integration_type=0&scope=bot+applications.commands" />
            </div>
        </header>
    );
}

export default Header;